import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash-es';

import { GfTranslateService } from '../../../services/core.translate.service';
import { UiService } from '../../../services/core.ui.service';
import { AdminService } from '../../../services/core.admin.service';
import { gfBoolFilter} from "../../../pipes/data/data.functions";

@Component({
    selector: 'adminAuthenticationView',
    template: require('./admin.authentication.component.html')
})

export class SiteAdminAuthViewComponent implements OnInit {

    // private choices = ['ON', 'OFF'];
    protected choices = {};

    protected errors: any = {};
    protected saving = false;
    protected authSettings: any = {};
    protected optionalOAuth: any = {};
    protected extraAuthSettings: { [key: string]: any } = {};

    //Base auth settings structure
    private baseSettings = {
        oauth: {
            enable: false,
            label: '',
            logoUrl: '',
            hostName: '',
            clientId: '',
            clientSecret: ''
        },
        microsoft: {
            enable: false,
            tenantId: '',
            clientId: '',
            clientSecret: ''
        }
    };

    constructor(
        private adminService: AdminService,
        private gfTranslateService: GfTranslateService, 
        private uiService: UiService
    ) { }
    
    ngOnInit() {
        this.choices[this.gfTranslateService.translate('ON')] = true;
        this.choices[this.gfTranslateService.translate('OFF')] = false;
    
        this.initErrors();
        this.adminService.getExtraAuthSettings()
        .then((data) => {
            var items = _.get(data, 'items', {});
            this.extraAuthSettings = this.mapExtraAuthSettings(items);
        }, (err) => {
            console.log(err);
        }
        )

        this.adminService.getAuthMethods()
        .then((data) => {
            var settings = _.get(data, 'data', {});
            if (!settings.optionalOAuth) {
                settings.optionalOAuth = _.clone(this.baseSettings);
            }
            this.authSettings = settings;
            this.optionalOAuth = settings.optionalOAuth;
        }, (err) => {
            console.log(err);
        });        
    }

    initErrors() {
        this.errors = {
            oauth: {
                label: { hasError: false, error: '' },
                logoUrl: { hasError: false, error: '' },
                hostName: { hasError: false, error: '' },
                clientId: { hasError: false, error: '' },
                clientSecret: { hasError: false, error: '' }
            },
            microsoft: {
                tenantId: { hasError: false, error: '' },
                clientId: { hasError: false, error: '' },
                clientSecret: { hasError: false, error: '' }
            },
            extra: {
                maxLoginAttempts: { hasError: false, error: '' },
                registrationTokenTTL: { hasError: false, error: '' },
                userPasswordAging: { hasError: false, error: '' }
            }
        };
    }

    validate() {
        this.initErrors();

        var isValid = true;

        // Checks if OAuth is enabled (handles boolean or string 'true')
        let oauthEnabled = _.get(this.optionalOAuth, 'oauth.enable', false);
        if (String(oauthEnabled) === 'true') oauthEnabled = true;

        if (oauthEnabled) {
            const requiredFields = ['label', 'hostName', 'clientId', 'clientSecret'];
            requiredFields.forEach(field => {
                if (!this.validateRequiredField('oauth', field)) {
                    isValid = false;
                }
            });
        }

        // Checks if Microsoft is enabled (it handles both boolean or string 'true')
        let microsoftEnabled = _.get(this.optionalOAuth, 'microsoft.enable', false);
        if (String(microsoftEnabled) === 'true') microsoftEnabled = true;

        if (microsoftEnabled) {
            const requiredFields = ['clientId', 'clientSecret'];
            requiredFields.forEach(field => {
                if (!this.validateRequiredField('microsoft', field)) {
                    isValid = false;
                }
            });
        }

        if (!this.validatePositiveInteger(this.extraAuthSettings['maxLoginAttempts'], 'maxLoginAttempts')) isValid = false;
        if (!this.validatePositiveInteger(this.extraAuthSettings['registrationTokenTTL'], 'registrationTokenTTL')) isValid = false;
        if (!this.validatePositiveInteger(this.extraAuthSettings['system.user_password_aging'], 'userPasswordAging')) isValid = false;

        return isValid;
    }

    validatePositiveInteger(value, fieldName) {
        if (value === undefined || value === null || String(value).trim() === '') {
            return true;
        }

        const isInteger = /^\d+$/.test(String(value));
        
        if (!this.errors['extra']) this.errors['extra'] = {};

        if (!isInteger) {
            this.errors['extra'][fieldName] = {
                hasError: true,
                error: this.gfTranslateService.translate('Must be a positive integer or zero')
            };
            return false;
        } else {
            this.errors['extra'][fieldName] = { hasError: false };
            return true;
        }
    }

    validateRequiredField(provider, fieldName) {
        const value = _.get(this.optionalOAuth, `${provider}.${fieldName}`, '');
        
        if (!this.errors[provider]) {
             this.errors[provider] = {};
        }

        if (!value || String(value).trim() === '') {
            this.errors[provider][fieldName] = {
                hasError: true,
                error: this.gfTranslateService.translate('This field is required')
            };
        } else {
            this.errors[provider][fieldName] = {
                hasError: false
            };
        }
        return !this.errors[provider][fieldName].hasError;
    }

    mapExtraAuthSettings(items: { [key: string]: any }): { [key: string]: any } {
        var extraAuthSettings = _.clone(items)
        for (const key in extraAuthSettings) {
            if (key == 'system.approveUsers' || key == 'system.use-captcha' || key == 'system.notifyAdminAccountLock') {
                if (gfBoolFilter(extraAuthSettings[key])) {
                    extraAuthSettings[key] = true;
                } else {
                    extraAuthSettings[key] = false;
                }
            }
        }

        return extraAuthSettings;
    }

    setOAuthEnabled = (provider, value) => {
        console.log("setOAuthEnabled", provider, value);
        _.set(this.optionalOAuth, provider + '.enable', value);
    };

    setExtraAuthSetting = (settingName, value) => {
        if (settingName == 'system.approveUsers' || settingName == 'system.use-captcha' || settingName == 'system.notifyAdminAccountLock') {
            if (value) {
                this.extraAuthSettings[settingName] = this.choices[this.gfTranslateService.translate('ON')];
            } else {
                this.extraAuthSettings[settingName] = this.choices[this.gfTranslateService.translate('OFF')];
            }
        }
    };



    saveSettings = () => {
        if (!this.validate()) return;

        this.saving = true;

        this.adminService.postConfig({ section: 'config', refId: 0, settingName: 'authentication', settingValue: this.optionalOAuth })
        .then(() => {
            return this.adminService.postAuthSettings({'settings':this.extraAuthSettings});
        })
        .then(() => {
            this.uiService.message.showSuccess(this.gfTranslateService.translate('Authentication settings were successfully saved'), this.gfTranslateService.translate('Settings saved'));
            this.saving = false;
        })
        .catch((error) => {
            this.uiService.message.showSuccess(this.gfTranslateService.translate('Authentication settings failed to save'), this.gfTranslateService.translate('Settings not saved'));
            console.log(error);
            this.saving = false;
        });
    }
}
